import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "@/i18n";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Intro from "@/components/Intro";
import About from "@/components/About";
import Classes from "@/components/Classes";
import Experiences from "@/components/Experiences";
import Place from "@/components/Place";
import Marquee from "@/components/Marquee";
import Why from "@/components/Why";
import Community from "@/components/Community";
import Testimonial from "@/components/Testimonial";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import SoundHealing from "@/pages/SoundHealing";
import ClassesPage from "@/pages/ClassesPage";
import BookingPage from "@/pages/BookingPage";
import Seo from "@/components/Seo";

const Home = () => (
  <main>
    <Hero />
    <Intro />
    <About />
    <Classes />
    <Experiences />
    <Place />
    <Marquee />
    <Why />
    <Community />
    <Testimonial />
    <FinalCTA />
  </main>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => { lenis.raf(time); rafId = requestAnimationFrame(raf); };
    rafId = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(rafId); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <LangProvider>
      <div className="bg-ivory text-charcoal">
        <BrowserRouter>
          <Seo />
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/classes" element={<ClassesPage />} />
            <Route path="/sound-healing" element={<SoundHealing />} />
            <Route path="/booking" element={<BookingPage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    </LangProvider>
  );
}

export default App;
